import {
  hasCookiePermission,
  getLocalStorage,
  setLocalStorage,
  removeLocalStorage
} from "../components/layout/cookies/CookieFunctions";
import packageJson from "../../package.json";
import { getEnvironmentVariable } from "../global/environmentVariables";

const CACHE_KEY = "rootTranslation";
const CACHE_DURATION_HOURS = 12;
const TRANSLATION_VERSION = "1.1.0";

export function hasPerformanceCookiePermission(authContext) {
  return hasCookiePermission("rootTranslation", authContext);
}

export function getCachedTranslation(authContext) {
  if (authContext && !hasPerformanceCookiePermission(authContext)) {
    return null;
  }

  try {
    const cachedData = authContext 
      ? getLocalStorage(CACHE_KEY, authContext)
      : localStorage?.getItem(CACHE_KEY);
    
    if (!cachedData) {
      return null;
    }

    const parsedCache = JSON.parse(cachedData);

    if (
      !parsedCache.dateModified ||
      !parsedCache.version ||
      !parsedCache.translation ||
      !parsedCache.translationVersion
    ) {
      return null;
    }

    if (!isCacheValid(parsedCache.dateModified, parsedCache.version, parsedCache.translationVersion)) {
      if (authContext) {
        removeLocalStorage(CACHE_KEY);
      } else {
        localStorage?.removeItem(CACHE_KEY);
      }
      return null;
    }

    return parsedCache.translation;
  } catch (error) {
    if (authContext) {
      removeLocalStorage(CACHE_KEY);
    } else {
      localStorage?.removeItem(CACHE_KEY);
    }
    return null;
  }
}

export function setCachedTranslation(translation, authContext) {
  if (authContext && !hasPerformanceCookiePermission(authContext)) {
    return;
  }

  if (!translation) {
    return;
  }

  try {
    const cacheObject = {
      dateModified: new Date().toISOString(),
      version: getEnvironmentVariable("AWS_DEPLOY_VERSION")
        ? getEnvironmentVariable("AWS_DEPLOY_VERSION")
        : packageJson.version,
      translationVersion: TRANSLATION_VERSION,
      translation: translation
    };

    const cacheString = JSON.stringify(cacheObject);
    
    if (authContext) {
      setLocalStorage(CACHE_KEY, cacheString, authContext);
    } else {
      localStorage?.setItem(CACHE_KEY, cacheString);
    }
  } catch (error) {
    console.warn("Failed to cache translation:", error);
  }
}

function isCacheValid(dateModified, version, translationVersion) {
  const cacheDate = new Date(dateModified);
  const currentDate = new Date();
  const hoursDifference = (currentDate - cacheDate) / (1000 * 60 * 60);

  if (hoursDifference > CACHE_DURATION_HOURS) {
    return false;
  }

  if (version !== packageJson.version) {
    return false;
  }

  if (translationVersion !== TRANSLATION_VERSION) {
    return false;
  }

  return true;
}
